import { throttle } from "throttle-debounce";
import isInView from '../utilities/isInView';

const initAnimatedIcons = () => {

	// Track the number triggered so we can remove the scroll event when complete
	let iconsTriggered = 0;

	// Used to detect if an element is in view
	const isInViewport = (element) => {
		const rect = element.getBoundingClientRect();

		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	// Throttle for performance reasons
	const throttleIconCheck = throttle(750, () => {
		const iconElements = document.getElementsByClassName('o-animated-ring');

		// Loop through each icon
		Array.from(iconElements).forEach(element => {
			
			// If in view and not already triggered
			if( isInView(element) ) {
				if( !element.classList.contains('trigger') ) {

					// Add a class when in view and increment iconsTrigered
					element.classList.add('trigger');
					iconsTriggered++;
					
					// If we have triggered all of the icons, remove the scroll listener
					if( iconsTriggered === iconElements.length ) {
						window.removeEventListener('scroll', throttleIconCheck);
					}
				}
			}
		});
	});
			
	// Check once when loaded and then on scroll
	throttleIconCheck();
	window.addEventListener( 'scroll', throttleIconCheck, {passive: true} );

}

export default initAnimatedIcons;